import { BubbleChartSelectedFieldType } from './types';
import type { FieldNameAndLabel } from './types';

export type AvailableReferenceModeFields = {
  availableBubbleComponentFields: FieldNameAndLabel[];
  availableReferenceFields: FieldNameAndLabel[];
  availableReferencedComponentFields: FieldNameAndLabel[];
};

export const getAvailableFieldsOfType = (
  type: BubbleChartSelectedFieldType,
  {
    availableBubbleComponentFields,
    availableReferenceFields,
    availableReferencedComponentFields,
  }: AvailableReferenceModeFields
): FieldNameAndLabel[] => {
  switch (type) {
    case BubbleChartSelectedFieldType.BUBBLE_COMPONENT:
      return availableBubbleComponentFields;
    case BubbleChartSelectedFieldType.REFERENCE:
      return availableReferenceFields;
    case BubbleChartSelectedFieldType.REFERENCED_COMPONENT:
      return availableReferencedComponentFields;
  }
};
